import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, DialogActions, DialogContent, Divider, IconButton, Toolbar, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useMemo, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useService } from '~/services/service.base';
import { MediaSearchService } from '~/services/service.media.search';
import { UIService } from '~/services/service.ui';
import { plainToModel } from '~/tools/plain.model';
import { useNavigate } from 'react-router-dom';
import { ModelSearchConnectedUser } from '~/models/model.search.connected.user';
import { ROUTES } from '~/routes/routes';
import { FormikProvider } from 'formik';
import { useFormikModel } from '~/tools/formik.model';
import { validatorConnectedUserSearch } from '~/views/organisms/search/connected-user-search/validator.connected.user.search';
import { Button } from '~/views/atoms/button';
import { FormMediaSearchConnectedUser } from '~/views/molecules/form-media-search-connected-user/form.media.search.connected.user';
import { Icons } from '~/views/atoms/icons';
import { styled } from '@mui/system';
const sxToolbar = { height: UIService.TOOLBAR_SEARCH_HEIGHT, justifyContent: 'space-between', gap: 1 };
export const ConnectedUserSearch = observer(() => {
    const { t } = useTranslation();
    const mediaSearchService = useService(MediaSearchService);
    const { searchFieldSvc, handleClickBack } = mediaSearchService;
    const navigate = useNavigate();
    const initialValues = useMemo(() => plainToModel(ModelSearchConnectedUser, {}), []);
    const StyledButton = styled(Button)({
        '&.MuiButtonBase-root': { boxShadow: `0px -2px 12px 0px rgba(0, 0, 0, 0.08)` },
    });
    const onSubmit = useCallback((data) => {
        mediaSearchService.resetData();
        mediaSearchService.setOrder('title ASC');
        mediaSearchService.setFilterType(undefined);
        const searchParams = JSON.stringify({
            addedBy: data.owner,
            name: data.fileName,
            description: data.title,
            date_format: data.formatDate?.id,
            date: data.date,
            country_id: data.country?.id,
            location_id: data.location,
            author_id: data.author?.id,
            physical_form_id: data.fitness?.id,
            depository_id: data.depository?.id,
            stockage_id: data.archivalSymbol?.id,
            comments: data.commentaries,
            details: data.additionalDetails,
        });
        mediaSearchService.getMediaItems(undefined, searchParams);
        mediaSearchService.openDialogSvc.handleClose();
        mediaSearchService.openSearchSvc.handleClose();
        navigate(ROUTES.FUNDS.MEDIA.SEARCH_RESULT.path, { state: { searchParams, query: undefined } });
    }, [mediaSearchService, navigate]);
    const resetFilterForm = useCallback(() => {
        mediaSearchService.resetData();
        searchFieldSvc.handleClear();
        mediaSearchService.openDialogSvc.handleClose();
        navigate(ROUTES.FUNDS.path);
    }, [mediaSearchService, navigate, searchFieldSvc]);
    const formik = useFormikModel(ModelSearchConnectedUser, {
        initialValues,
        onSubmit,
        validateOnMount: true,
        validateOnChange: true,
        validate: validatorConnectedUserSearch,
    });
    return (_jsxs(FormikProvider, { value: formik, children: [_jsxs(AppBar, { color: "inherit", position: "relative", children: [_jsxs(Toolbar, { sx: sxToolbar, children: [_jsx(IconButton, { color: "inherit", onClick: handleClickBack, children: _jsx(Icons.Back, {}) }), _jsxs(Fragment, { children: [_jsx(Typography, { variant: "h2", children: t('SEARCH_DIALOG_INFO_SHEET') }), _jsx(IconButton, { color: "inherit", onClick: resetFilterForm, children: _jsx(Icons.Close, { color: "primary" }) })] })] }), _jsx(Divider, {})] }), _jsx(DialogContent, { children: _jsx(FormMediaSearchConnectedUser, {}) }), _jsx(DialogActions, { children: _jsx(StyledButton, { disabled: !formik.isValid, fullWidth: true, onClick: formik.submitForm, children: t('SEARCH_DIALOG_SEARCH') }) })] }));
});
